//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 1. 获取奖品prizeList
 * 2. 开始抽奖
 */
export default {
  name: 'Lottery',
  data() {
    return {
      openid: '',
      userId: '',
      userType: '',
      lotteryProjectCode: '',
      lotteryProjectConfig: {
        address: ''
      },
      prizeList: [
        { name: '一等奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_01.png', weight: 1 },
        { name: '二等奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_02.png', weight: 2 },
        { name: '三等奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_03.png', weight: 3 },
        { name: '纪念奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_jnj.png', weight: 5 },
        { name: '谢谢参与', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_xxcy.png', weight: 8 },
        { name: '幸运奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_xyj.png', weight: 5 },
        { name: '纪念奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_jnj.png', weight: 5 },
        { name: '谢谢参与', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_xxcy.png', weight: 8 },
        { name: '幸运奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_xyj.png', weight: 5 },
        { name: '纪念奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_jnj.png', weight: 5 },
        { name: '谢谢参与', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_xxcy.png', weight: 8 },
        { name: '幸运奖', img: 'https://cargoyun-weixin.oss-cn-beijing.aliyuncs.com/nbzh/prize_xyj.png', weight: 5 }
      ],
      loadingTip: '正在加载奖品图片 (0/12) ...',
      resultDisplay: '✨ 等待图片加载 ✨',
      secretHint: '',
      imagesLoaded: false,
      isSpinning: false,
      prizeImages: [],
      loadedCount: 0,
      currentAngle: 0,
      animFrame: null,
      startTime: null,
      startAngle: 0,
      deltaAngle: 0,
      targetIndex: 0,
      fixedIndex: null,
      fixedPrize: null,
      secretClickCount: 0,
      secretTimer: null,
      ctx: null
    }
  },
  created () {
    const p = new URLSearchParams(location.search)
    this.openid = p.get('openid') || ''
    if (this.$Utils.IsEmpty(this.openid)) {
      this.openid = this.$UserUtils.getWxOpenId();
    }
    // 抽奖活动代码
    this.lotteryProjectCode = p.get('lotteryProjectCode') || ''
    // 领奖地址
    this.lotteryProjectConfig.address = p.get('address') || ''
    this.userId = p.get('userId') || ''
    this.userType = p.get('userType') || ''
    this.lotteryProjectConfig.address = p.get('address') || ''
    console.log('created')
  },
  async mounted() {
    await this.getPrizeList()
    console.log('mounted')
    this.ctx = this.$refs.wheelCanvas.getContext('2d')
    this.loadImages()
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame)
    if (this.secretTimer) clearTimeout(this.secretTimer)
  },
  methods: {
    // 从服务器端获取奖品List
    async getPrizeList () {
      let that = this;
      let url = '/lottery/prize/getLotteryPrizeListByLotteryProjectCode';
      try {
        // 1. 等待接口请求完成（捕获网络/接口错误）
        let res = await that.$axios.post(url, null, {
          params: {lotteryProjectCode: that.lotteryProjectCode}
        });

        // 2. 处理接口返回结果
        if (res.meta.success) {
          // 关键：把接口返回的奖品数据赋值给 prizeList
          that.prizeList = res.data.map(item => ({
            name: item.name,    // 奖品名称
            img: item.image,    // 奖品图片
            weight: item.probability, // 中奖概率（权重）
            id: item.id         // 奖品ID
          }));
        } else {
          // 接口返回失败提示
          that.$Msgbox.alert(res.meta.message);
          that.prizeList = []; // 兜底空数组
        }
      } catch (err) {
        // 捕获网络错误/接口报错（如404、500）
        console.error('奖品列表请求失败：', err);
        that.$Msgbox.alert('网络异常，无法获取奖品列表');
        that.prizeList = []; // 兜底空数组
      }
    },
    // 提交后端抽奖，返回中奖商品id，根据id定位fixedIndex
    async submitLottery() {
      let that = this;
      let url = '/lottery/submitLottery';
      let res = await that.$axios.post(url, null, {params: {lotteryProjectCode: that.lotteryProjectCode, userId: that.userId, openId: that.openid, userType: that.userType, loading: true}});
      if (res.meta.success) {
        if (!res.data || !res.data.prize_id) {
          that.fixedIndex = null;
          that.$Msgbox.alert('抽奖失败');
        } else {
          that.fixedPrize = res.data;
          let fixedPrizeId = that.$Utils.IsEmpty(that.fixedPrize.prize_id) ? null : Number(that.fixedPrize.prize_id);
          that.fixedIndex = that.prizeList.findIndex(function (item) {
            return item.id === fixedPrizeId;
          });
          if (that.fixedIndex === -1) {
            that.fixedIndex = null;
          }
        }
      } else {
        that.fixedIndex = null;
        that.$Msgbox.alert(res.meta.message);
      }
    },
    // 权重随机
    getRandomIndexByWeight() {
      const totalWeight = this.prizeList.reduce((sum, p) => sum + p.weight, 0)
      let rand = Math.random() * totalWeight
      let cumulative = 0
      for (let i = 0; i < this.prizeList.length; i++) {
        cumulative += this.prizeList[i].weight
        if (rand < cumulative) return i
      }
      return this.prizeList.length - 1
    },
    // 图片加载
    loadImages() {
      this.loadedCount = 0
      this.prizeImages = []
      const total = this.prizeList.length
      this.loadingTip = `正在加载奖品图片 (0/${total}) ...`

      this.prizeList.forEach((prize, index) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
          this.loadedCount++
          this.prizeImages[index] = img
          this.loadingTip = `正在加载奖品图片 (${this.loadedCount}/${total}) ...`
          if (this.loadedCount === total) {
            this.imagesLoaded = true
            this.loadingTip = '奖品加载完成，可以开始抽奖'
            this.resultDisplay = '✨ 请开始抽奖 ✨'
            this.drawWheel()
          }
        }
        img.onerror = () => {
          const fallbackCanvas = document.createElement('canvas')
          fallbackCanvas.width = 40
          fallbackCanvas.height = 40
          const fCtx = fallbackCanvas.getContext('2d')
          fCtx.fillStyle = '#d35400'
          fCtx.fillRect(0, 0, 40, 40)
          fCtx.fillStyle = '#fff'
          fCtx.font = 'bold 20px sans-serif'
          fCtx.textAlign = 'center'
          fCtx.textBaseline = 'middle'
          fCtx.fillText(prize.name.charAt(0), 20, 20)

          const fallbackImg = new Image()
          fallbackImg.src = fallbackCanvas.toDataURL()
          fallbackImg.onload = () => {
            this.loadedCount++
            this.prizeImages[index] = fallbackImg
            this.loadingTip = `正在加载奖品图片 (${this.loadedCount}/${total}) ...`
            if (this.loadedCount === total) {
              this.imagesLoaded = true
              this.loadingTip = '图片加载完成，可以开始抽奖'
              this.drawWheel()
            }
          }
        }
        img.src = prize.img
      })
    },
    // 绘制转盘
    drawWheel() {
      const ctx = this.ctx
      if (!ctx) return
      ctx.clearRect(0, 0, 400, 400)
      const count = this.prizeList.length
      const angleStep = (Math.PI * 2) / count
      const centerX = 200
      const centerY = 200
      const radius = 170

      for (let i = 0; i < count; i++) {
        const start = i * angleStep + this.currentAngle
        const end = (i + 1) * angleStep + this.currentAngle

        ctx.beginPath()
        ctx.moveTo(centerX, centerY)
        ctx.arc(centerX, centerY, radius, start, end)
        ctx.closePath()
        ctx.fillStyle = i % 2 === 0 ? '#FF6B6B' : '#FFB347'
        ctx.fill()
        ctx.strokeStyle = '#fff3e0'
        ctx.lineWidth = 1.5
        ctx.stroke()

        ctx.beginPath()
        ctx.moveTo(centerX, centerY)
        ctx.lineTo(centerX + Math.cos(start) * radius, centerY + Math.sin(start) * radius)
        ctx.strokeStyle = '#ffe4b5'
        ctx.lineWidth = 2.5
        ctx.stroke()

        const midAngle = start + angleStep / 2
        const imgRadius = radius * 0.65
        const imgX = centerX + Math.cos(midAngle) * imgRadius
        const imgY = centerY + Math.sin(midAngle) * imgRadius

        const img = this.prizeImages[i]
        if (img && img.complete && img.naturalWidth) {
          ctx.save()
          ctx.translate(imgX, imgY)
          ctx.rotate(midAngle + Math.PI / 2)
          ctx.shadowColor = '#b85e1b'
          ctx.shadowBlur = 8
          ctx.shadowOffsetY = 2
          const size = 36
          ctx.drawImage(img, -size / 2, -size / 2, size, size)
          ctx.restore()
        } else {
          ctx.save()
          ctx.beginPath()
          ctx.arc(imgX, imgY, 18, 0, 2 * Math.PI)
          ctx.fillStyle = '#d35400'
          ctx.shadowColor = '#8b4513'
          ctx.shadowBlur = 6
          ctx.fill()
          ctx.shadowBlur = 0
          ctx.fillStyle = '#fff'
          ctx.font = 'bold 16px sans-serif'
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.fillText(i + 1, imgX, imgY)
          ctx.restore()
        }

        ctx.save()
        ctx.font = 'bold 13px system-ui, sans-serif'
        const textRadius = imgRadius + 30
        const textX = centerX + Math.cos(midAngle) * textRadius
        const textY = centerY + Math.sin(midAngle) * textRadius

        ctx.translate(textX, textY)
        ctx.rotate(midAngle + Math.PI / 2)
        ctx.fillStyle = '#fff7e6'
        ctx.shadowColor = '#b85e1b'
        ctx.shadowBlur = 4
        ctx.shadowOffsetY = 1
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText(this.prizeList[i].name, 0, 0)
        ctx.restore()
      }

      ctx.beginPath()
      ctx.arc(centerX, centerY, 28, 0, 2 * Math.PI)
      ctx.fillStyle = '#ffa726'
      ctx.shadowBlur = 12
      ctx.shadowColor = '#b85e1b'
      ctx.fill()
      ctx.shadowBlur = 0
      ctx.strokeStyle = '#ffd966'
      ctx.lineWidth = 4
      ctx.stroke()

      ctx.beginPath()
      ctx.arc(centerX, centerY, 10, 0, 2 * Math.PI)
      ctx.fillStyle = '#8b4513'
      ctx.fill()
    },
    // 缓动
    easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3)
    },
    // 旋转动画
    spinAnimation(now) {
      if (!this.isSpinning) return
      let total = 2000;
      let elapsed = now - this.startTime
      /* if ((!this.fixedIndex) && elapsed >= total) {
        total = elapsed + 20;
      } */
      console.log('转动-------------：' + elapsed + '--------------fixedIndex：' + this.fixedIndex + '----------------total: ' + total)
      let progress = Math.min(elapsed / total, 1)
      const eased = this.easeOutCubic(progress)

      this.currentAngle = (this.startAngle + this.deltaAngle * eased) % (2 * Math.PI)
      this.drawWheel()

      if (progress < 1) {
        this.animFrame = requestAnimationFrame(this.spinAnimation)
      } else {
        this.stopSpinAndGoToClaim()
      }
    },
    // 停止并跳转领奖页
    stopSpinAndGoToClaim() {
      if (this.animFrame) {
        cancelAnimationFrame(this.animFrame)
        this.animFrame = null
      }
      this.isSpinning = false

      const prize = this.prizeList[this.targetIndex]

      const params = new URLSearchParams({
        name: prize.name,
        img: prize.img,
        code: this.fixedPrize.verify_code,
        qrticket: this.fixedPrize.verify_code_qr_ticket,
        address: this.lotteryProjectConfig.address,
        status: this.fixedPrize.verify_status,
        iswin: this.fixedPrize.is_win,
        id: this.fixedPrize.id,
        lotteryProjectCode: this.lotteryProjectCode
      })

      // 跳转领奖页
      this.$router.push('/wx/lottery/result?openid=' + this.openid + '&' + params.toString())

      // 清除暗箱
      if (this.fixedIndex !== null) {
        this.fixedIndex = null
        this.fixedPrize = null
        this.secretHint = ''
      }
    },
    // 开始抽奖
    async startSpin() {
      if (this.isSpinning || !this.imagesLoaded) return

      await this.submitLottery();

      if (this.fixedIndex === null) return;

      if (this.fixedIndex !== null && this.fixedIndex >= 0 && this.fixedIndex < this.prizeList.length) {
        this.targetIndex = this.fixedIndex
        this.secretHint = `🔮 暗箱模式：将抽中【${this.prizeList[this.targetIndex].name}】`
      } else {
        this.targetIndex = this.getRandomIndexByWeight()
        if (this.fixedIndex !== null) {
          this.fixedIndex = null
          this.secretHint = ''
        }
      }

      const count = this.prizeList.length
      const angleStep = (Math.PI * 2) / count
      const targetRawAngle = this.targetIndex * angleStep + angleStep / 2
      const pointerAngle = -Math.PI / 2
      let targetAngle = (pointerAngle - targetRawAngle + 2 * Math.PI) % (2 * Math.PI)

      let delta = (targetAngle - this.currentAngle + 2 * Math.PI) % (2 * Math.PI)
      const extraRounds = 4 + Math.floor(Math.random() * 5)
      delta += extraRounds * 2 * Math.PI

      this.startAngle = this.currentAngle
      this.deltaAngle = delta
      this.startTime = performance.now()

      this.isSpinning = true
      this.resultDisplay = '🌀 转盘转动中......'

      if (this.animFrame) cancelAnimationFrame(this.animFrame)
      this.animFrame = requestAnimationFrame(this.spinAnimation)
    },
    // 重置 & 暗箱触发
    handleReset() {
      /* if (this.secretTimer) clearTimeout(this.secretTimer)
      this.secretClickCount++

      this.secretTimer = setTimeout(() => {
        this.secretClickCount = 0
      }, 5000) */

      /* if (this.secretClickCount >= 5) {
        this.secretClickCount = 0
        clearTimeout(this.secretTimer)
        const input = prompt(`请输入想要指定的奖品序号（0 ~ ${this.prizeList.length - 1}）：`, '0')
        if (input !== null) {
          const index = parseInt(input, 10)
          if (!isNaN(index) && index >= 0 && index < this.prizeList.length) {
            this.fixedIndex = index
            this.secretHint = `🔮 暗箱已激活：下一次将抽中【${this.prizeList[index].name}】`
          } else {
            alert('输入无效，暗箱未激活')
          }
        }
        return
      } */

      if (this.isSpinning) {
        if (this.animFrame) cancelAnimationFrame(this.animFrame)
        this.isSpinning = false
      }
      this.currentAngle = 0
      this.drawWheel()
      this.resultDisplay = '✨ 转盘已重置，点击抽奖 ✨'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/lottery/Lottery.vue